import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#8e99f3",
      main: "#5c6bc0",
      dark: "#26418f",
      contrastText: "#fff",
    },
    secondary: {
      light: "#534bae",
      main: "#1a237e",
      dark: "#000051",
      contrastText: "#fff",
    },
  },
});

export default theme;
